// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zHttpErrorResponseDto = z.object({
    message: z.union([
        z.string(),
        z.array(z.string())
    ]),
    statusCode: z.number(),
    error: z.string().optional()
});

export const zWebConfigResponseDto = z.object({
    GOOGLE_CLIENT_ID: z.string().optional(),
    GOOGLE_API_KEY: z.string().optional(),
    DROPBOX_CLIENT_ID: z.string().optional(),
    MICROSOFT_APPLICATION_CLIENT_ID: z.string().optional(),
    MICROSOFT_APPLICATION_AUTHORITY: z.string(),
    FEATURE_SERVER_SYNC_ENABLED: z.boolean(),
    SHOW_DISABLED_PLUGINS: z.boolean()
});

export const zPublicServerSourceDto = z.object({
    id: z.string(),
    name: z.string()
});

export const zObokuErrorDto = z.object({
    code: z.enum([
        '0',
        '2000',
        '3000',
        '3001',
        '3002',
        '3003',
        '3004',
        '3005',
        '3006',
        '4000',
        '4001',
        '4002',
        '4003',
        '4004',
        '5000',
        '6000',
        '6001',
        '7000',
        '8000',
        '8001',
        '9000',
        '10000'
    ])
});

export const zObokuErrorResponseDto = z.object({
    errors: z.array(zObokuErrorDto)
});

export const zAuthProofPublicKeyDto = z.object({
    kty: z.string(),
    crv: z.string(),
    x: z.string().max(256),
    y: z.string().max(256)
});

export const zSignInWithEmailDto = z.object({
    email: z.email(),
    password: z.string(),
    installation_id: z.string(),
    public_key: zAuthProofPublicKeyDto
});

export const zAuthSessionResponseDto = z.object({
    dbName: z.string(),
    email: z.string(),
    nameHex: z.string(),
    sessionId: z.string()
});

export const zSignInWithGoogleDto = z.object({
    token: z.string(),
    installation_id: z.string(),
    public_key: zAuthProofPublicKeyDto
});

export const zRequestSignUpDto = z.object({
    email: z.email()
});

export const zEmptyResponseDto = z.record(z.string(), z.unknown());

export const zCompleteSignUpDto = z.object({
    token: z.string(),
    password: z.string().min(8)
});

export const zCompleteSignUpResponseDto = z.object({
    email: z.string()
});

export const zRequestMagicLinkDto = z.object({
    email: z.email()
});

export const zCompleteMagicLinkDto = z.object({
    token: z.string(),
    installation_id: z.string(),
    public_key: zAuthProofPublicKeyDto
});

export const zLogoutDto = z.object({
    session_id: z.uuid()
});

export const zAdminSignInDto = z.object({
    login: z.string(),
    password: z.string()
});

export const zAdminTokensResponseDto = z.object({
    access_token: z.string(),
    refresh_token: z.string()
});

export const zAdminRefreshTokenDto = z.object({
    refresh_token: z.string()
});

export const zWebdavConnectorsMigrationResponseDto = z.object({
    usersMigrated: z.number(),
    connectorsCreated: z.number()
});

export const zResourceIdMigrationResponseDto = z.object({
    usersMigrated: z.number(),
    linksUpdated: z.number(),
    collectionsUpdated: z.number()
});

export const zCollectionCoverKeysMigrationResponseDto = z.object({
    storageStrategy: z.enum(['s3', 'fs']),
    ranOnUsers: z.number(),
    renamed: z.number(),
    skippedDestinationExists: z.number(),
    skippedSourceMissing: z.number()
});

export const zRefreshTokenCreatedAtResetResponseDto = z.object({
    updated: z.number()
});

export const zCoverCleanupStatsResponseDto = z.object({
    storageStrategy: z.enum(['s3', 'fs']),
    storageLocation: z.string(),
    storedCovers: z.number().nullable(),
    storedSizeInBytes: z.number().nullable(),
    canDeleteAllCovers: z.boolean()
});

export const zFailedCoverDeletionDto = z.object({
    key: z.string(),
    message: z.string()
});

export const zDeleteAllCoversResponseDto = z.object({
    deletedCovers: z.number(),
    deletedSizeInBytes: z.number(),
    failedCovers: z.number(),
    failedKeys: z.array(zFailedCoverDeletionDto)
});

export const zGenerateSignUpLinkDto = z.object({
    email: z.email(),
    appPublicUrl: z.url().optional()
});

export const zSignUpLinkResponseDto = z.object({
    signUpLink: z.string()
});

export const zAdminNotificationSummaryDto = z.object({
    data: z.null(),
    id: z.number(),
    createdAt: z.string(),
    kind: z.enum(['admin_broadcast']),
    severity: z.enum([
        'error',
        'success',
        'info',
        'warning'
    ]),
    title: z.string(),
    body: z.string().nullable(),
    deliveredCount: z.number()
});

export const zCreateAdminNotificationDto = z.object({
    title: z.string().min(1),
    body: z.string().optional(),
    severity: z.enum([
        'info',
        'success',
        'warning',
        'error'
    ]).optional(),
    audienceType: z.enum(['all', 'emails']),
    emails: z.array(z.email()).max(1000).optional()
});

export const zAdminUserSummaryDto = z.object({
    id: z.number(),
    email: z.string(),
    username: z.string(),
    emailVerified: z.boolean(),
    hasPassword: z.boolean(),
    createdAt: z.string()
});

export const zSendAdminEmailDto = z.object({
    subject: z.string().min(1),
    body: z.string().min(1),
    audienceType: z.enum(['all', 'emails']),
    emails: z.array(z.email()).max(1000).optional()
});

export const zSendAdminEmailResponseDto = z.object({
    recipientCount: z.number()
});

export const zTokenStatsResponseDto = z.object({
    totalTokens: z.number(),
    activeTokens: z.number(),
    distinctUsers: z.number(),
    distinctSessions: z.number()
});

export const zRevokeTokensDto = z.object({
    audienceType: z.enum(['all', 'emails']),
    emails: z.array(z.email()).max(1000).optional()
});

export const zRevokeTokensResponseDto = z.object({
    revokedTokens: z.number(),
    targetedUsers: z.number().nullable()
});

export const zInstanceSettingsResponseDto = z.object({
    showDisabledPlugins: z.boolean(),
    fileDownloadMaxSizeBytes: z.number(),
    allowPrivateNetworkRequests: z.boolean(),
    privateNetworkAllowedHosts: z.array(z.string()),
    microsoftApplicationClientId: z.string().optional(),
    microsoftApplicationAuthority: z.string().optional(),
    opdsServersMaxPerUser: z.number()
});

export const zUpdateInstanceSettingsDto = z.object({
    fileDownloadMaxSizeBytes: z.int().gte(1).optional(),
    microsoftApplicationAuthority: z.union([
        z.url(),
        z.enum([''])
    ]).optional(),
    opdsServersMaxPerUser: z.int().gte(1).optional(),
    showDisabledPlugins: z.boolean().optional(),
    allowPrivateNetworkRequests: z.boolean().optional(),
    privateNetworkAllowedHosts: z.array(z.string()).max(100).optional(),
    microsoftApplicationClientId: z.string().optional()
});

export const zServerSyncCredentialsDto = z.object({
    configured: z.boolean(),
    username: z.string().nullable()
});

export const zServerSyncResponseDto = z.object({
    enabled: z.boolean(),
    credentials: zServerSyncCredentialsDto
});

export const zUpdateServerSyncDto = z.object({
    enabled: z.boolean()
});

export const zUpdateServerSyncResponseDto = z.object({
    enabled: z.boolean()
});

export const zSetWebDavCredentialsDto = z.object({
    username: z.string().min(1),
    password: z.string().min(8)
});

export const zWebDavCredentialsResponseDto = z.object({
    configured: z.boolean(),
    username: z.string()
});

export const zServerSourceDto = z.object({
    id: z.string(),
    name: z.string(),
    path: z.string(),
    enabled: z.boolean()
});

export const zCreateServerSourceDto = z.object({
    name: z.string().min(1),
    path: z.string().min(1),
    enabled: z.boolean().optional()
});

export const zUpdateServerSourceDto = z.object({
    name: z.string().min(1).optional(),
    path: z.string().min(1).optional(),
    enabled: z.boolean().optional()
});

export const zOkResponseDto = z.object({
    ok: z.boolean()
});

export const zAdminBroadcastNotificationDto = z.object({
    data: z.null(),
    kind: z.enum(['admin_broadcast']),
    id: z.number(),
    createdAt: z.string(),
    severity: z.enum([
        'error',
        'success',
        'info',
        'warning'
    ]),
    title: z.string(),
    body: z.string().nullable(),
    seenAt: z.string().nullable(),
    archivedAt: z.string().nullable()
});

export const zSyncFinishedNotificationDataDto = z.object({
    datasourceId: z.string(),
    state: z.enum(['error', 'success'])
});

export const zSyncFinishedNotificationDto = z.object({
    kind: z.enum(['sync_finished']),
    data: zSyncFinishedNotificationDataDto,
    id: z.number(),
    createdAt: z.string(),
    severity: z.enum([
        'error',
        'success',
        'info',
        'warning'
    ]),
    title: z.string(),
    body: z.string().nullable(),
    seenAt: z.string().nullable(),
    archivedAt: z.string().nullable()
});

export const zUnreadNotificationsCountResponseDto = z.object({
    count: z.number()
});

export const zSyncReportRelationDto = z.object({
    id: z.string(),
    label: z.string().optional(),
    rx_model: z.enum([
        'link',
        'datasource',
        'obokucollection',
        'tag',
        'book'
    ])
});

export const zSyncReportEntryDto = z.object({
    rx_model: z.enum([
        'link',
        'datasource',
        'obokucollection',
        'tag',
        'book'
    ]),
    id: z.string(),
    label: z.string().optional(),
    linkedTo: z.array(zSyncReportRelationDto).optional(),
    unlinkedTo: z.array(zSyncReportRelationDto).optional(),
    fetchedMetadata: z.boolean().optional(),
    hasDifferentProviderCredentials: z.boolean().optional(),
    added: z.boolean().optional(),
    updated: z.boolean().optional(),
    deleted: z.boolean().optional()
});

export const zSyncReportDto = z.object({
    id: z.number(),
    created_at: z.iso.datetime(),
    ended_at: z.iso.datetime(),
    state: z.enum(['error', 'success']),
    report: z.array(zSyncReportEntryDto),
    datasource_id: z.string(),
    user_name: z.string(),
    has_different_provider_credentials: z.boolean().nullable()
});

export const zSyncDataSourceDto = z.object({
    dataSourceId: z.string(),
    providerCredentials: z.record(z.string(), z.unknown())
});

export const zRefreshBookMetadataDto = z.object({
    bookId: z.string(),
    force: z.boolean().optional(),
    providerCredentials: z.record(z.string(), z.unknown())
});

export const zRefreshCollectionMetadataDto = z.object({
    collectionId: z.string(),
    soft: z.boolean().optional(),
    providerCredentials: z.record(z.string(), z.unknown())
});

export const zKoreaderSyncServerResponseDto = z.object({
    username: z.string(),
    passwordCreatedAt: z.string().nullable()
});

export const zKoreaderSyncServerPasswordResponseDto = z.object({
    username: z.string(),
    password: z.string()
});

export const zKoreaderSyncConnectionDto = z.object({
    serverUrl: z.string(),
    username: z.string(),
    connectedAt: z.string()
});

export const zKoreaderSyncConnectionResponseDto = z.object({
    connection: zKoreaderSyncConnectionDto.nullable()
});

export const zConnectKoreaderSyncServerDto = z.object({
    serverUrl: z.url(),
    username: z.string().min(1),
    password: z.string().min(1)
});

export const zPushKoreaderSyncPositionDto = z.object({
    document: z.string().regex(/^[A-Za-z0-9_]+$/),
    progress: z.string().min(1),
    percentage: z.number().gte(0).lte(1),
    deviceId: z.string().min(1)
});

export const zKoreaderSyncPositionDto = z.object({
    progress: z.string(),
    percentage: z.number(),
    device: z.string().nullable(),
    deviceId: z.string().nullable(),
    updatedAt: z.string().nullable()
});

export const zKoreaderSyncPositionResponseDto = z.object({
    position: zKoreaderSyncPositionDto.nullable()
});

export const zOpdsServerDto = z.object({
    id: z.number(),
    slug: z.string(),
    name: z.string(),
    username: z.string(),
    createdAt: z.string()
});

export const zOpdsServerPasswordResponseDto = z.object({
    server: zOpdsServerDto,
    password: z.string()
});

export const zRenameOpdsServerDto = z.object({
    name: z.string().min(1).max(100).regex(/\S/)
});

export const zAppGetHelloResponse = z.string();

export const zWebGetConfigResponse = zWebConfigResponseDto;

export const zWebListServerSourcesResponse = z.array(zPublicServerSourceDto);

export const zAuthSignInWithEmailBody = zSignInWithEmailDto;

export const zAuthSignInWithEmailResponse = zAuthSessionResponseDto;

export const zAuthSignInWithGoogleBody = zSignInWithGoogleDto;

export const zAuthSignInWithGoogleResponse = zAuthSessionResponseDto;

export const zAuthRequestSignUpBody = zRequestSignUpDto;

export const zAuthRequestSignUpResponse = zEmptyResponseDto;

export const zAuthCompleteSignUpBody = zCompleteSignUpDto;

export const zAuthCompleteSignUpResponse = zCompleteSignUpResponseDto;

export const zAuthRequestMagicLinkBody = zRequestMagicLinkDto;

export const zAuthRequestMagicLinkResponse = zEmptyResponseDto;

export const zAuthCompleteMagicLinkBody = zCompleteMagicLinkDto;

export const zAuthCompleteMagicLinkResponse = zAuthSessionResponseDto;

export const zAuthRefreshTokenQuery = z.object({
    grant_type: z.enum(['refresh_token'])
});

export const zAuthRefreshTokenResponse = zEmptyResponseDto;

export const zAuthLogoutBody = zLogoutDto;

export const zAuthLogoutResponse = zEmptyResponseDto;

export const zAuthDeleteAccountResponse = zEmptyResponseDto;

export const zCoversFindBookCoverPath = z.object({
    bookId: z.string()
});

export const zCoversFindBookCoverQuery = z.object({
    format: z.enum(['image/webp', 'image/jpeg']).optional()
});

export const zCoversFindBookCoverResponse = z.string();

export const zCoversFindCollectionCoverPath = z.object({
    collectionId: z.string()
});

export const zCoversFindCollectionCoverQuery = z.object({
    format: z.enum(['image/webp', 'image/jpeg']).optional()
});

export const zCoversFindCollectionCoverResponse = z.string();

export const zAdminSignInBody = zAdminSignInDto;

export const zAdminSignInResponse = zAdminTokensResponseDto;

export const zAdminRefreshTokenBody = zAdminRefreshTokenDto;

export const zAdminRefreshTokenResponse = zAdminTokensResponseDto;

export const zAdminMigrateWebdavConnectorsResponse = zWebdavConnectorsMigrationResponseDto;

export const zAdminMigrateWebdavResourceIdsResponse = zResourceIdMigrationResponseDto;

export const zAdminMigrateResourceIdToLinkDataResponse = zResourceIdMigrationResponseDto;

export const zAdminMigrateCollectionCoverKeysResponse = zCollectionCoverKeysMigrationResponseDto;

export const zAdminResetRefreshTokenCreatedAtResponse = zRefreshTokenCreatedAtResetResponseDto;

export const zAdminGetCoversCleanupStatsResponse = zCoverCleanupStatsResponseDto;

export const zAdminDeleteAllCoversResponse = zDeleteAllCoversResponseDto;

export const zAdminGenerateSignUpLinkBody = zGenerateSignUpLinkDto;

export const zAdminGenerateSignUpLinkResponse = zSignUpLinkResponseDto;

export const zAdminListNotificationsResponse = z.array(zAdminNotificationSummaryDto);

export const zAdminCreateNotificationBody = zCreateAdminNotificationDto;

export const zAdminCreateNotificationResponse = zAdminNotificationSummaryDto;

export const zAdminListUsersResponse = z.array(zAdminUserSummaryDto);

export const zAdminSendEmailBody = zSendAdminEmailDto;

export const zAdminSendEmailResponse = zSendAdminEmailResponseDto;

export const zAdminGetTokenStatsResponse = zTokenStatsResponseDto;

export const zAdminRevokeTokensBody = zRevokeTokensDto;

export const zAdminRevokeTokensResponse = zRevokeTokensResponseDto;

export const zAdminGetSettingsResponse = zInstanceSettingsResponseDto;

export const zAdminUpdateSettingsBody = zUpdateInstanceSettingsDto;

export const zAdminUpdateSettingsResponse = zEmptyResponseDto;

export const zAdminGetServerSyncResponse = zServerSyncResponseDto;

export const zAdminUpdateServerSyncBody = zUpdateServerSyncDto;

export const zAdminUpdateServerSyncResponse = zUpdateServerSyncResponseDto;

export const zAdminSetWebDavCredentialsBody = zSetWebDavCredentialsDto;

export const zAdminSetWebDavCredentialsResponse = zWebDavCredentialsResponseDto;

export const zAdminListServerSourcesResponse = z.array(zServerSourceDto);

export const zAdminCreateServerSourceBody = zCreateServerSourceDto;

export const zAdminCreateServerSourceResponse = zServerSourceDto;

export const zAdminDeleteServerSourcePath = z.object({
    id: z.string()
});

export const zAdminDeleteServerSourceResponse = zOkResponseDto;

export const zAdminUpdateServerSourceBody = zUpdateServerSourceDto;

export const zAdminUpdateServerSourcePath = z.object({
    id: z.string()
});

export const zAdminUpdateServerSourceResponse = zServerSourceDto;

export const zAdminGetSessionResponse = zOkResponseDto;

export const zNotificationsListResponse = z.array(z.union([zAdminBroadcastNotificationDto, zSyncFinishedNotificationDto]));

export const zNotificationsUnreadCountResponse = zUnreadNotificationsCountResponseDto;

export const zNotificationsMarkAllAsSeenResponse = zOkResponseDto;

export const zNotificationsMarkAsSeenPath = z.object({
    id: z.number()
});

export const zNotificationsMarkAsSeenResponse = zOkResponseDto;

export const zNotificationsArchivePath = z.object({
    id: z.number()
});

export const zNotificationsArchiveResponse = zOkResponseDto;

export const zDataSourcesListSyncReportsResponse = z.array(zSyncReportDto);

export const zDataSourcesSyncBody = zSyncDataSourceDto;

export const zDataSourcesSyncResponse = zEmptyResponseDto;

export const zBooksRefreshMetadataBody = zRefreshBookMetadataDto;

export const zBooksRefreshMetadataResponse = zEmptyResponseDto;

export const zCollectionsRefreshMetadataBody = zRefreshCollectionMetadataDto;

export const zCollectionsRefreshMetadataResponse = zEmptyResponseDto;

export const zKoreaderSyncServerTurnOffResponse = zOkResponseDto;

export const zKoreaderSyncServerGetResponse = zKoreaderSyncServerResponseDto;

export const zKoreaderSyncServerCreatePasswordResponse = zKoreaderSyncServerPasswordResponseDto;

export const zKoreaderSyncConnectionDisconnectResponse = zOkResponseDto;

export const zKoreaderSyncConnectionGetResponse = zKoreaderSyncConnectionResponseDto;

export const zKoreaderSyncConnectionConnectBody = zConnectKoreaderSyncServerDto;

export const zKoreaderSyncConnectionConnectResponse = zKoreaderSyncConnectionResponseDto;

export const zKoreaderSyncConnectionPushPositionBody = zPushKoreaderSyncPositionDto;

export const zKoreaderSyncConnectionPushPositionResponse = zOkResponseDto;

export const zKoreaderSyncConnectionPullPositionPath = z.object({
    document: z.string()
});

export const zKoreaderSyncConnectionPullPositionResponse = zKoreaderSyncPositionResponseDto;

export const zOpdsServersListResponse = z.array(zOpdsServerDto);

export const zOpdsServersCreateResponse = zOpdsServerPasswordResponseDto;

export const zOpdsServersDeletePath = z.object({
    id: z.number()
});

export const zOpdsServersDeleteResponse = zOkResponseDto;

export const zOpdsServersRenameBody = zRenameOpdsServerDto;

export const zOpdsServersRenamePath = z.object({
    id: z.number()
});

export const zOpdsServersRenameResponse = zOpdsServerDto;

export const zOpdsServersRegeneratePasswordPath = z.object({
    id: z.number()
});

export const zOpdsServersRegeneratePasswordResponse = zOpdsServerPasswordResponseDto;
